"use client";

import { createContext, type ReactNode, useContext } from "react";

import type { Config } from "@jti/fe-common";

type ConsentReminderMode = NonNullable<Config["consentReminderMode"]>;

const ConsentReminderModeContext = createContext<ConsentReminderMode>("legacy");

export const ConsentReminderModeProvider = ({
  children,
  consentReminderMode,
}: {
  children: ReactNode;
  consentReminderMode: ConsentReminderMode;
}) => <ConsentReminderModeContext.Provider value={consentReminderMode}>{children}</ConsentReminderModeContext.Provider>;

export const useConsentReminderMode = () => useContext(ConsentReminderModeContext);
